var _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgPercentageSpeedometerIcon(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 23,
    height: 16,
    viewBox: "0 0 23 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_3418_3431)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M12.6688 9.34872C12.9093 8.52416 13.1413 7.69667 13.3718 6.86919C13.4685 6.52136 13.3584 6.2684 13.0669 6.13705C12.7749 6.0057 12.5047 6.0884 12.299 6.37882C11.7948 7.09004 11.2966 7.80515 10.785 8.51102C10.7315 8.58448 10.6026 8.6521 10.5134 8.64723C8.55124 8.53583 6.92374 10.0128 6.89746 12.019C6.90539 12.1167 6.90886 12.2962 6.93662 12.4719C7.15921 13.8938 8.28602 15.02 9.70928 15.2491C11.1539 15.4816 12.5841 14.8045 13.2622 13.5669C13.9642 12.2855 13.7649 10.7498 12.7501 9.69314C12.644 9.58271 12.6277 9.49029 12.6688 9.34921V9.34872ZM9.01327 10.0264C9.41729 10.022 9.74497 10.3363 9.74398 10.7284C9.74349 11.1161 9.40639 11.4362 9.00831 11.4279C8.61469 11.4196 8.30387 11.1083 8.30535 10.7235C8.30635 10.3372 8.61767 10.0308 9.01376 10.0264H9.01327ZM9.30476 13.6121C9.08118 13.8306 8.80555 13.8452 8.59883 13.6613C8.38418 13.4701 8.36435 13.1724 8.58941 12.9486C9.48174 12.0603 10.382 11.1798 11.2847 10.3022C11.4409 10.1499 11.6392 10.0935 11.8533 10.1932C12.0422 10.2813 12.1369 10.4326 12.1409 10.7167C12.1062 10.7736 12.0566 10.9069 11.9644 10.9988C11.0825 11.874 10.1936 12.7433 9.30476 13.6117V13.6121ZM11.5633 13.9152C11.1707 13.922 10.8346 13.5995 10.8316 13.2128C10.8287 12.8255 11.1593 12.4952 11.55 12.4957C11.9386 12.4962 12.2767 12.8309 12.2722 13.2113C12.2678 13.5868 11.9441 13.9084 11.5638 13.9152H11.5633Z",
    fill: "url(#paint0_linear_3418_3431)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M20.154 4.9209C18.997 5.76833 17.8553 6.60408 16.6987 7.45151C17.6243 8.75574 18.0843 10.1942 18.1324 11.7529H22.7462C22.6173 9.19551 21.7676 6.92856 20.154 4.9209Z",
    fill: "url(#paint1_linear_3418_3431)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11.8636 0.705566C11.7466 1.90715 11.6326 3.08149 11.5166 4.27431C13.1912 4.55257 14.615 5.27109 15.8265 6.42937C16.7803 5.42141 17.7212 4.42657 18.6765 3.41666C16.6951 1.78699 14.4494 0.881669 11.8636 0.705566Z",
    fill: "url(#paint2_linear_3418_3431)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9.79766 0.771851C7.31352 1.10168 5.19176 2.1004 3.38232 3.79721C4.04265 4.50794 4.69008 5.20505 5.34197 5.90703C6.74441 4.80858 8.32086 4.24816 10.0921 4.182C9.99298 3.03248 9.89631 1.9136 9.79766 0.771851Z",
    fill: "url(#paint3_linear_3418_3431)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0.138433 11.7558H2.44311C2.49021 9.94569 3.096 8.35202 4.27536 6.93396C3.54068 6.3823 2.82384 5.84378 2.09065 5.29358C0.720924 7.25892 0.0799355 9.39841 0.138433 11.7558Z",
    fill: "url(#paint4_linear_3418_3431)"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_3418_3431",
    x1: 10.2875,
    y1: 6.07642,
    x2: 10.2875,
    y2: 15.2945,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#EB0054"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#4935C3"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_3418_3431",
    x1: 19.7225,
    y1: 4.9209,
    x2: 19.7225,
    y2: 11.7529,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#EB0054"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#4935C3"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_3418_3431",
    x1: 15.0966,
    y1: 0.705566,
    x2: 15.0966,
    y2: 6.42937,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#EB0054"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#4935C3"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_3418_3431",
    x1: 6.73723,
    y1: 0.771851,
    x2: 6.73723,
    y2: 5.90703,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#EB0054"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#4935C3"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint4_linear_3418_3431",
    x1: 2.20506,
    y1: 5.29358,
    x2: 2.20506,
    y2: 11.7558,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#EB0054"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#4935C3"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_3418_3431"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 22.6126,
    height: 14.5887,
    fill: "white",
    transform: "translate(0.134277 0.705566)"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgPercentageSpeedometerIcon);
export default __webpack_public_path__ + "static/media/percentage-speedometer-icon.2b4896f97d6ce6656f8c89f1efc5ba92.svg";
export { ForwardRef as ReactComponent };